import { configureStore } from "@reduxjs/toolkit";
import SidebarSlice from "./Slices/SidebarSlice";
import authReducer from "./Slices/AuthSlice";

const store = configureStore({
  reducer: {
    sidebar: SidebarSlice,
    auth: authReducer,
  },
});

export default store;
